import React from 'react';

const panelStyle = {
  width: 280,
  background: '#16213e',
  borderLeft: '1px solid #333',
  padding: 16,
  overflowY: 'auto',
  color: '#eee',
  fontFamily: 'sans-serif',
};

const btnStyle = {
  padding: '10px 16px',
  background: '#0f3460',
  color: '#fff',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  fontSize: 13,
  width: '100%',
  marginBottom: 8,
};

export default function FlipPanel({ editor }) {
  return (
    <div style={panelStyle}>
      <h3 style={{ margin: '0 0 12px', fontSize: 14 }}>Flip</h3>
      <button style={btnStyle} onClick={() => editor.flip({ direction: 'horizontal' })}>
        ↔ Flip Horizontal
      </button>
      <button style={btnStyle} onClick={() => editor.flip({ direction: 'vertical' })}>
        ↕ Flip Vertical
      </button>
    </div>
  );
}
